/* Merino.tech EU, "Merino Prime" 48-hour offer. Window in European time: Oct 6 2026 00:00 CEST -> Oct 8 2026 00:00
   Lisbon / Dublin time (the latest midnight in mainland Europe; 01:00 CEST). The same dates are set on the discounts.
   1. Ladder plaque on product pages: any order 15% (LAYERUP15) | EUR 200+ free socks 3-pack | EUR 300+ 20% (LAYERUP20).
      Thresholds are compared with the cart AFTER the 15% offer. The code is applied by itself once the cart has items,
      and a tap on the first tier applies it at once (the plaque says "Applied" even while the cart is empty).
   2. Free gift: when the cart reaches EUR 200 a pop-up offers Merino Wool Hunting Socks (Pack of 3) Black in M or L.
      The chosen pair is added with the line property "_mt_gift"; the automatic discount "Layer Up free socks" makes it free.
      If the cart falls under the threshold, the gift line is removed.
   Outside the offer window nothing is shown. QA: add ?mtdeal=1 to the URL to force the offer. Settings come from snippets/mt-layer-up. */
(function () {
  'use strict';
  if (window.__mtLayerUp) return;
  window.__mtLayerUp = true;
  var CFG = window.MT_LAYERUP || {};
  var START = CFG.start || Date.UTC(2026, 9, 5, 22, 0, 0), END = CFG.end || Date.UTC(2026, 9, 7, 23, 0, 0);
  var FORCE = location.search.indexOf('mtdeal=1') !== -1;
  var C1 = 'LAYERUP15', C3 = 'LAYERUP20', R1 = 15, R3 = 20, M2 = 20000, M3 = 30000;
  var GIFT_PROP = '_mt_gift', SKIP_KEY = 'mt_gift_skip', CLAIM_KEY = 'mt_layerup_claim';
  var sub = 0, inFlight = '', lastSent = '', autoTried = false, giftBusy = false, cartRef = null;

  /* the code the shopper has claimed: lets the plaque say "Applied" right after a tap, even with an empty cart */
  function claim() { try { return localStorage.getItem(CLAIM_KEY) || ''; } catch (e) { return ''; } }
  function setClaim(c) { try { localStorage.setItem(CLAIM_KEY, c); } catch (e) {} }
  function isDeal() { var t = Date.now(); return t < END && (t >= START || FORCE); }
  function eff(s) { return Math.round(s * (100 - R1) / 100); }
  function eur(c, ceil) { return '\u20AC' + (ceil ? Math.ceil(c / 100) : Math.round(c / 100)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function left() {
    var s = Math.max(0, Math.floor((END - Date.now()) / 1000)), d = Math.floor(s / 86400); s %= 86400;
    var h = Math.floor(s / 3600); s %= 3600; var m = Math.floor(s / 60); s %= 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }
  function giftLine(cart) {
    var found = null;
    (cart && cart.items || []).forEach(function (it) { if (it.properties && it.properties[GIFT_PROP]) found = it; });
    return found;
  }
  function codesOf(cart) {
    var out = [];
    (cart && cart.discount_codes || []).forEach(function (d) { if (d && d.code && d.applicable !== false) out.push(String(d.code).toUpperCase()); });
    return out;
  }

  /* ---------- plaque ---------- */
  function build() {
    if (document.querySelector('.mtw') || !/\/products\//.test(location.pathname)) return;
    var forms = document.querySelectorAll('main form[action*="/cart/add"]'), form = null;
    for (var i = 0; i < forms.length; i++) { if (forms[i].querySelector('[name="id"]')) { form = forms[i]; break; } }
    if (!form) return;
    var el = document.createElement('div');
    el.className = 'mtw mtw--deal';
    el.setAttribute('data-mt-wknd', '');
    el.hidden = true;
    el.innerHTML =
      '<div class="mtw__top"><span class="mtw__eyebrow">Merino Prime is here</span><span class="mtw__title">Two days only. Layer up for less.</span></div>' +
      '<div class="mtw__cd"><span class="mtw__cd-dot"></span><span>Ends in</span><b data-cd>&nbsp;</b></div>' +
      '<div class="mtw__steps">' +
      '<button type="button" class="mtw__step" data-s1><span class="mtw__pct"><span class="mtw__lbl">Any</span>order</span><span class="mtw__copy"><span class="mtw__val">15% off</span><span class="mtw__note">No minimum &middot; gift cards excluded</span></span><span class="mtw__cta" data-t1>Apply</span></button>' +
      '<button type="button" class="mtw__step" data-s2><span class="mtw__pct"><span class="mtw__lbl">From</span>&euro;200</span><span class="mtw__copy"><span class="mtw__val">15% off + free socks 3&#8209;pack</span><span class="mtw__note">Pick your size, we add them to your cart</span></span><span class="mtw__cta" data-t2>&euro;200</span></button>' +
      '<button type="button" class="mtw__step" data-s3><span class="mtw__pct"><span class="mtw__lbl">From</span>&euro;300</span><span class="mtw__copy"><span class="mtw__val">20% off + free socks 3&#8209;pack</span><span class="mtw__note">The best rate &mdash; applies on its own</span></span><span class="mtw__cta" data-t3>&euro;300</span></button>' +
      '</div><div class="mtw__track"><span class="mtw__fill" data-fill></span><span class="mtw__tick" style="left:66.67%"></span></div>' +
      '<p class="mtw__msg" data-msg aria-live="polite"></p>';
    form.parentNode.insertBefore(el, form);
    el.addEventListener('click', function (e) {
      var b = e.target.closest('.mtw__step');
      if (!b) return;
      if (b.hasAttribute('data-s2')) { if (eff(sub) >= M2 && cartRef && !giftLine(cartRef)) openGift(true); return; }
      if (b.hasAttribute('data-s3') && eff(sub) < M3) return;
      lastSent = '';
      sendCode(eff(sub) >= M3 ? C3 : C1);
    });
  }
  function paint(codes) {
    var el = document.querySelector('.mtw');
    if (!el) return;
    if (!isDeal()) { el.hidden = true; return; }
    var e = eff(sub), on2 = e >= M2, on3 = e >= M3;
    var cl = claim(), has1 = codes.indexOf(C1) !== -1 || cl === C1, has3 = codes.indexOf(C3) !== -1 || cl === C3, gift = cartRef && giftLine(cartRef);
    var s1 = el.querySelector('[data-s1]'), s2 = el.querySelector('[data-s2]'), s3 = el.querySelector('[data-s3]');
    s1.classList.toggle('is-on', !on2); s1.classList.toggle('is-done', has1 && !on2); s1.classList.toggle('is-dim', on2);
    s2.classList.toggle('is-on', on2 && !on3); s2.classList.toggle('is-done', on2 && !on3 && !!gift); s2.classList.toggle('is-dim', on3);
    s3.classList.toggle('is-on', on3); s3.classList.toggle('is-done', on3 && has3);
    el.querySelector('[data-t1]').textContent = inFlight === C1 ? 'Applying' : (has1 || has3 ? 'Applied' : 'Apply');
    el.querySelector('[data-t2]').textContent = !on2 ? eur(M2 - e, true) + ' to go' : (gift ? 'Socks added' : 'Pick size');
    el.querySelector('[data-t3]').textContent = on3 ? (has3 ? 'Applied' : 'Applying') : eur(M3 - e, true) + ' to go';
    el.querySelector('[data-fill]').style.width = Math.min(100, Math.round(e / M3 * 100)) + '%';
    var off = Math.round(sub * (on3 ? R3 : R1) / 100), msg = el.querySelector('[data-msg]');
    if (sub === 0) msg.innerHTML = '15% on anything. <b>&euro;200</b> adds free socks, <b>&euro;300</b> makes it 20%.';
    else if (!on2) msg.innerHTML = 'You save <b>' + eur(off) + '</b> now. <b>' + eur(M2 - e, true) + ' more</b> in cart adds free socks.';
    else if (!on3) msg.innerHTML = 'You save <b>' + eur(off) + '</b> and get free socks. <b>' + eur(M3 - e, true) + ' more</b> in cart for 20%.';
    else msg.innerHTML = 'You save <b>' + eur(off) + '</b> and get free socks. Best rate on the ladder.';
    el.hidden = false;
  }
  function tick() {
    var cd = document.querySelector('.mtw [data-cd]');
    if (cd && isDeal()) cd.textContent = left();
  }

  /* ---------- discount codes ---------- */
  function sendCode(code) {
    if (!code || lastSent === code) return;
    lastSent = code; inFlight = code; setClaim(code);
    paint([code]);
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { inFlight = ''; refresh(); })
      .catch(function () { inFlight = ''; });
  }

  /* ---------- free gift ---------- */
  function openGift(manual) {
    if (document.querySelector('.mtg') || !CFG.gift) return;
    if (!manual) { try { if (sessionStorage.getItem(SKIP_KEY)) return; } catch (e) {} }
    var m = document.createElement('div');
    m.className = 'mtg';
    m.innerHTML = '<div class="mtg__box" role="dialog" aria-modal="true" aria-labelledby="mtg-t">' +
      '<button type="button" class="mtg__x" data-close aria-label="Close">&times;</button>' +
      (CFG.gift.image ? '<img class="mtg__img" src="' + CFG.gift.image + '" alt="" width="120" height="120">' : '') +
      '<p class="mtg__eyebrow">Free gift unlocked</p>' +
      '<h2 class="mtg__title" id="mtg-t">Pick your free socks</h2>' +
      '<p class="mtg__text">' + CFG.gift.title + ' are on us. Choose your size and we add them to your cart for &euro;0.</p>' +
      '<div class="mtg__sizes">' + CFG.gift.sizes.map(function (s) {
        return '<button type="button" class="mtg__size" data-variant="' + s.id + '"' + (s.available ? '' : ' disabled') + '>' + s.label + (s.available ? '' : ' (sold out)') + '</button>';
      }).join('') + '</div>' +
      '<p class="mtg__err" data-err role="alert" hidden>Could not add the socks. Please try again.</p>' +
      '<button type="button" class="mtg__skip" data-close>No thanks</button></div>';
    document.body.appendChild(m);
    var first = m.querySelector('.mtg__size:not([disabled])') || m.querySelector('[data-close]');
    if (first) first.focus();
    function close(skip) {
      if (skip) { try { sessionStorage.setItem(SKIP_KEY, '1'); } catch (e) {} }
      document.removeEventListener('keydown', onKey);
      m.remove();
    }
    function onKey(e) { if (e.key === 'Escape') close(true); }
    document.addEventListener('keydown', onKey);
    m.addEventListener('click', function (e) {
      if (e.target === m || e.target.closest('[data-close]')) { close(true); return; }
      var b = e.target.closest('.mtg__size');
      if (!b || giftBusy) return;
      var label = b.textContent;
      giftBusy = true; b.textContent = 'Adding...';
      var props = {}; props[GIFT_PROP] = 'Merino Prime free gift';
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-variant')), quantity: 1, properties: props }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { location.reload(); })
        .catch(function () { giftBusy = false; b.textContent = label; m.querySelector('[data-err]').hidden = false; });
    });
  }
  function dropGift(line) {
    if (giftBusy) return;
    giftBusy = true;
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 }) })
      .then(function () { giftBusy = false; if (/^\/cart/.test(location.pathname)) location.reload(); else refresh(); })
      .catch(function () { giftBusy = false; });
  }

  /* ---------- cart ---------- */
  function handle(cart) {
    cartRef = cart;
    var gift = giftLine(cart);
    sub = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) || 0;
    if (gift) sub = Math.max(0, sub - (gift.final_line_price || 0));
    var codes = codesOf(cart);
    paint(codes);
    if (!isDeal()) { if (gift) dropGift(gift); return; }
    var e = eff(sub), on3 = e >= M3;
    if (gift && e < M2) { dropGift(gift); return; }
    if (inFlight === '') {
      if (on3 && codes.indexOf(C3) === -1) { sendCode(C3); return; }
      if (!on3 && codes.indexOf(C3) !== -1) { sendCode(C1); return; }
      if (sub > 0 && !codes.length && !autoTried) { autoTried = true; lastSent = ''; sendCode(on3 ? C3 : C1); return; }
      if ((on3 && codes.indexOf(C3) !== -1) || (!on3 && codes.indexOf(C3) === -1)) lastSent = '';
    }
    if (e >= M2 && !gift && sub > 0) openGift(false);
  }
  var pending = null;
  function refresh() {
    if (pending) return pending;
    pending = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(handle).catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }
  function isWrite(u) { return typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u); }
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var u = (arguments[0] && arguments[0].url) || arguments[0] || '', r = nativeFetch.apply(this, arguments);
    if (isWrite(u)) r.then(function () { setTimeout(refresh, 120); }).catch(function () {});
    return r;
  };
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (isWrite(u)) this.addEventListener('load', function () { setTimeout(refresh, 120); });
    return nativeOpen.apply(this, arguments);
  };

  function init() {
    if (!isDeal()) { refresh(); return; }
    build(); tick(); setInterval(function () { tick(); if (!isDeal()) paint([]); }, 1000);
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();